export default {
  fontIBMBold: 'DINPro-Bold, IBMPlexSans-SemiBold,  "Microsoft YaHei", Arial, sans-serif',
  fontIBMLight: 'DINPro-Light, IBMPlexSans-Light, "Microsoft YaHei", PingFangSC-Regular, Arial, sans-serif',
  fontIBMExtraLight: 'DINPro-Light, IBMPlexSans-ExtraLight, "Microsoft YaHei", PingFangSC-Regular, Arial, sans-serif',
  fontIBMSemiBold: 'DINPro-Medium, IBMPlexSans-SemiBold,  "Microsoft YaHei", Arial, sans-serif',
  fontIBMMedium: 'DINPro-Medium, IBMPlexSans-Medium,  "Microsoft YaHei", Arial, sans-serif',
  fontIBMRegular: 'DINPro, IBMPlexSans-Regular, "Microsoft YaHei", PingFangSC-Regular, Arial, sans-serif',
  contentMargin: '20px auto',
  maxWidth: '1260px',
  minWidth: '1200px',
  basictTradePageMaxWidth: '1260px',
  basictTradePageMinWidth: '1260px',
  backgroundWidth: '1440px',
  backgroundHeight: '570px',
  fontSizeSm: '12px',
  fontSizeMd: '14px',
  fontSizeLg: '16px',
  fontSizeXl: '18px',
  fontSizeXxl: '20px',
  verificationHeaderFontSize: '34px',
  verificationSubheaderFontSize: '24px',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightNormal: 500,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  primaryBtn: 'linear-gradient(90deg, #f0b90b 0%, #fbda3c 100%)',
  btnFontColor: '#212833',
};
